module.exports = __webpack_public_path__ + "img/indexBackGroupImage2.7b2707b6.png";